import { array, bool, func } from 'prop-types';
import Role from './Role';
import MenuHeaderInput from './MenuHeaderInput';
import Checkbox from '@mui/material/Checkbox';
import sty from '../styles/Roles.module.css';

/**
 * @component RoleList
 * @param { Object } props
 * @param { boolean } props.isCheckAll
 * @param { Array } props.groupRoles
 * @param { function } props.onCheck
 * @param { function } props.onCheckAll
 * @param { function } props.onHandle
 * @param { function } props.onCreate
 * @returns { JSX.Element }
 */
function RoleList(props) {
	const checkStyle = { '&.Mui-checked': { color: 'var(--cl-common-white)' } };

	const renderEmpty = (
		<div className={sty.role_list_empty}>-- No role have been selected yet. --</div>
	);

	return (
		<section className={sty.role_list_section}>
			<section className={sty.role_list_header}>
				<Checkbox
					className={sty.role_list_header_checkbox}
					sx={checkStyle}
					checked={props.isCheckAll}
					onClick={(e) => props.onCheckAll(e.target.checked)}
				/>
				<MenuHeaderInput value="Name" />
				<MenuHeaderInput value="Description" />
				<MenuHeaderInput value="Type" />
			</section>
			<section className={sty.role_list_list}>
				{props.groupRoles.length === 0 && renderEmpty}
				{props.groupRoles.map((role, index) => (
					<Role key={index} role={role} onCheck={props.onCheck} onHandle={props.onHandle} />
				))}
			</section>
		</section>
	);
}

RoleList.propTypes = {
	isCheckAll: bool,
	groupRoles: array,
	onCheck: func,
	onCheckAll: func,
	onHandle: func,
	onCreate: func,
};

export default RoleList;
